import React, { ComponentProps } from 'react';
import { Button, RowItem } from '@mattilsynet/mt-ui';
import './style.css';
export const ModalButton = ({
  ...rest
}: ComponentProps<typeof Button>) => <RowItem className="modal-button" margin={0.5} data-sentry-element="RowItem" data-sentry-component="ModalButton" data-sentry-source-file="index.tsx">
    <Button {...rest} data-sentry-element="Button" data-sentry-source-file="index.tsx" />
  </RowItem>;